<template>
  <div class="chart-container">
    <canvas ref="canvas" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { formatCurrencyValue } from 'dashboard/helper/opportunityDashboardHelper';

const CHART_COLORS = [
  '#1f93ff',
  '#ff4949',
  '#ffc532',
  '#3ac06f',
  '#8b5cf6',
  '#f97316',
  '#0ea5e9',
  '#64748b',
];

export default {
  extends: Doughnut,
  props: {
    lossReasons: { type: Array, required: true },
    mode: { type: String, default: 'count' },
    currency: { type: String, default: 'BRL' },
  },
  watch: {
    lossReasons() {
      this.updateChart();
    },
    mode() {
      this.updateChart();
    },
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      const labels = this.lossReasons.map(reason => reason.name);
      const data = this.lossReasons.map(reason =>
        this.mode === 'count' ? reason.count : reason.value
      );
      const backgroundColor = this.lossReasons.map(
        (_, index) => CHART_COLORS[index % CHART_COLORS.length]
      );

      this.renderChart(
        {
          labels,
          datasets: [{ data, backgroundColor, borderWidth: 1 }],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 65,
          legend: {
            position: 'right',
          },
          tooltips: {
            callbacks: {
              label: (item, chartData) => {
                const value = chartData.datasets[0].data[item.index];
                const total = chartData.datasets[0].data.reduce(
                  (sum, current) => sum + current,
                  0
                );
                const percentage = total
                  ? ((value / total) * 100).toFixed(1)
                  : 0;
                const displayValue =
                  this.mode === 'count'
                    ? value
                    : formatCurrencyValue(value, this.currency);
                return `${
                  chartData.labels[item.index]
                }: ${displayValue} (${percentage}%)`;
              },
            },
          },
        }
      );
    },
  },
};
</script>

<style scoped>
.chart-container {
  height: 16rem;
  position: relative;
}
</style>
